import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

export const StyledSearchField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    padding: theme.spacing(0, 1.5),
  },
  '& .MuiOutlinedInput-input': {
    padding: theme.spacing(1, 1.5),
    fontSize: 14,
  },
  '& .MuiInputAdornment-root': {
    marginTop: 0,
    marginBottom: 0,
  },
}));

export const ClearIconStyle = {
  padding: 0,
  cursor: 'pointer',
};

export const ConfirmIconStyle = {
  cursor: 'pointer',
};

export const StyledDivider = styled(Divider)(({ theme }) => ({
  height: 30,
  marginRight: theme.spacing(1.5),
}));
